(() => {
  const itemSelector = '[data-petvibess-product-search-item]';
  const normalize = (value) => value.toLocaleLowerCase().trim();

  const getItems = (section) => {
    const taggedItems = [...section.querySelectorAll(itemSelector)];
    if (taggedItems.length) return taggedItems;

    return [...section.querySelectorAll('#product-grid > .grid__item')]
      .filter((item) => item.querySelector('.card-wrapper--product, .card__heading__product-title'))
      .map((item) => {
        item.setAttribute('data-petvibess-product-search-item', '');
        item.dataset.productSearchText = item.textContent || '';
        return item;
      });
  };

  const initialize = (section) => {
    const toolbar = section.querySelector('.facets__toolbar');
    const count = toolbar?.querySelector('#ProductCount');
    if (!toolbar || !count || count.dataset.petvibessSearchReady === 'true') return;

    toolbar.querySelectorAll('.petvibess-collection-search, [data-petvibess-collection-search-status]').forEach((element) => element.remove());

    const originalCount = count.textContent.trim();
    count.dataset.petvibessSearchReady = 'true';
    count.classList.add('petvibess-product-count-search');
    count.innerHTML = `
      <button class="petvibess-product-search-trigger" type="button" aria-label="Search products">${originalCount}</button>
      <label class="visually-hidden" for="PetVibessCollectionSearch">Search products</label>
      <input id="PetVibessCollectionSearch" type="search" placeholder="Search products" autocomplete="off" data-petvibess-collection-search>
    `;

    const trigger = count.querySelector('.petvibess-product-search-trigger');
    const input = count.querySelector('[data-petvibess-collection-search]');
    const status = document.createElement('div');
    status.className = 'visually-hidden';
    status.setAttribute('aria-live', 'polite');
    status.dataset.petvibessCollectionSearchStatus = '';
    count.insertAdjacentElement('afterend', status);

    const closeSearch = () => {
      if (input.value) return;
      count.classList.remove('is-searching');
    };

    const applySearch = () => {
      const query = normalize(input.value);
      let matches = 0;

      getItems(section).forEach((item) => {
        const match = !query || normalize(item.dataset.productSearchText || '').includes(query);
        item.hidden = !match;
        if (match) matches += 1;
      });

      status.textContent = query ? `${matches} products match ${input.value}` : '';
    };

    trigger.addEventListener('click', () => {
      count.classList.add('is-searching');
      input.focus();
    });
    input.addEventListener('input', applySearch);
    input.addEventListener('blur', closeSearch);
    input.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      input.value = '';
      applySearch();
      input.blur();
    });
  };

  const initializeAll = () => document
    .querySelectorAll('.main-collection-product-grid-section')
    .forEach(initialize);

  document.addEventListener('DOMContentLoaded', initializeAll);
  document.addEventListener('shopify:section:load', initializeAll);
  initializeAll();
})();
